module.exports = __webpack_public_path__ + "img/Install-GBWhatsApp-Pro-APK-Latest-1536x1526.fd119b5b.webp";